import { render, staticRenderFns } from "./BusCls.vue?vue&type=template&id=f0cb07e0&"
import script from "./BusCls.vue?vue&type=script&lang=js&"
export * from "./BusCls.vue?vue&type=script&lang=js&"
import style0 from "./BusCls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BusCls.vue"
export default component.exports